import dayjs from 'dayjs';

import { VipTaskItemUserIdentifierTypesEnum } from '@shared/constants';
import { VipTaskItemModel } from '@shared/types';

import { VipTaskItemFormValues } from '../../VipSettingsForms';

export const getVipTaskItemFormValuesFromModel = (item: VipTaskItemModel): VipTaskItemFormValues => {
  const {
    id,
    userIdentifierType,
    joinedTournamentsStartDate,
    gameId,
    taskX,
    betLimit,
    lowerRangeX,
    upperRangeX,
    lowerLimitX,
    totalTaskX,
    countTaskX,
    ...restFields
  } = item;

  return {
    ...restFields,
    userIdentifierType: userIdentifierType || VipTaskItemUserIdentifierTypesEnum.EMAIL,
    joinedTournamentsStartDate: dayjs(joinedTournamentsStartDate),
    gameId: gameId || '',
    taskX: taskX || 0,
    betLimit: betLimit || 0,
    lowerRangeX: lowerRangeX || 0,
    upperRangeX: upperRangeX || 0,
    lowerLimitX: lowerLimitX || 0,
    totalTaskX: totalTaskX || 0,
    countTaskX: countTaskX || 0,
  };
};
